import { render, staticRenderFns } from "./TradingCentral.vue?vue&type=template&id=cb3f9cbc&"
import script from "./TradingCentral.vue?vue&type=script&lang=js&"
export * from "./TradingCentral.vue?vue&type=script&lang=js&"
import style0 from "./TradingCentral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports